import * as React from 'react';

import { Address } from 'common/api/models/Address';

export interface AddressProps {
  address?: Address;
}
export const AddressBlock: React.SFC<AddressProps> = props => {
  const address = props.address;
  if (!address) {
    return <span>None</span>;
  }
  const addressStr =
    (address.street1 ? address.street1 : '') +
    ' ' +
    (address.street2 ? address.street2 : '') +
    ' ' +
    address.city +
    ', ' +
    address.state +
    ', ' +
    address.country +
    ' ' +
    address.postal;
  const mapHref = 'https://www.google.com/maps/search/' + encodeURIComponent(addressStr);
  return (
    <address>
      {address.street1 && <div>{address.street1}</div>}
      {address.street2 && <div>{address.street2}</div>}
      <div>
        {address.city}, {address.state} {address.country} {address.postal}{' '}
        <small>
          <a href={mapHref} target="_blank">
            map
          </a>
        </small>
      </div>
    </address>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/AddressBlock.tsx